/*!
 * PatternFly Elements: SiteSwitcher 0.0.11
 * @license
 * Copyright 2020 Red Hat, Inc.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
*/

import PFElement from "../../../@patternfly/pfelement/dist/pfelement.js"; // | umd

class SiteSwitcher extends PFElement {
  static get version() {
    return "0.0.11";
  }

  get html() {
    return `<style>:host{display:block}:host([hidden]){display:none}
/*# sourceMappingURL=site-switcher.min.css.map */
</style><slot></slot>`;
  }
  static get tag() {
    return "site-switcher";
  }

  static get properties() {
    return {
      _lang: {
        title: "Language support",
        type: String,
        default: "en",
      },
    };
  }

  static get slots() {
    return {};
  }

  get templateUrl() {
    return "site-switcher.html";
  }

  get styleUrl() {
    return "site-switcher.scss";
  }

  // Declare the type of this component
  static get PfeType() {
    return PFElement.PfeTypes.Content;
  }

  constructor() {
    super(SiteSwitcher, { type: SiteSwitcher.PfeType });
    this._dataRequest = false;
  }

  connectedCallback() {
    super.connectedCallback();
    // If you need to initialize any attributes, do that here
    this._requestSiteSwitcher();
  }

  disconnectedCallback() {}

  //get markup and styles from rhdc endpoint and append
  //also called if lang attribute is updated
  _requestSiteSwitcher() {
    if (!this._dataRequest) {
      this._dataRequest = true;
      fetch("https://www.redhat.com/" + this._lang.toLowerCase() + "/cms/ajax/site-switcher")
        .then((response) => {
          if (!response.ok) {
            console.warn(`${SiteSwitcher.tag}: Something went wrong`);
            throw new Error();
          }
          return response.text();
        })
        .then((data) => {
          const parser = new DOMParser();
          const siteSwitcherHtml = parser.parseFromString(data, "text/html");

          // Prevent CSS that will load a bunch of fonts from loading, because it's
          // a good way to get worse performance on a lot of sites
          const badCode = siteSwitcherHtml.querySelector(
            'link[href*="red-hat-font.css"]'
          );
          if (badCode) badCode.remove();
          // Unfortunately the parser returns a whole doc with html/head/body, we just want the body contents
          this.append(siteSwitcherHtml.querySelector("body").children[0]);
        })
        .catch((err) => {
          this._siteSwitchLoadingIndicator.setAttribute("hidden", true);
          console.error(err);
        });
    }
  }
}

PFElement.create(SiteSwitcher);

export default SiteSwitcher;
